import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import { FieldWrapper, getFieldSize } from '@cian/frontend-request-form-widget';
import { Col } from '@cian/ui-kit';
import { EExtendedFieldTypes } from '../../types/requestForm';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionFieldWrapper = function QuestionFieldWrapper(_ref) {
  var field = _ref.field,
    fieldComponent = _ref.children;
  switch (field.type) {
    case EExtendedFieldTypes.HiddenField:
      {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: fieldComponent
        });
      }
    default:
      {
        return /*#__PURE__*/_jsx(Col, _objectSpread(_objectSpread({}, getFieldSize(field)), {}, {
          children: /*#__PURE__*/_jsx(FieldWrapper, {
            children: fieldComponent
          })
        }));
      }
  }
};